// extracted by mini-css-extract-plugin
export default {"fs":"_40e0f9d241 a1c0e35111"};